import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel
} from '@mui/material';
import { PaginationDesktop, SkeletonDesktop, TargetStatus } from '../../../../../components';
import { convertCentsToWhole, convertReadjustmentMonth } from '../../../../../utils/convert';
import { goToDatailsContract } from '../../../../../router/coordinator';
import { Order } from '../../../../../utils/enums';
import { hasPermission } from '../../../../../utils';

export function DesktopTable({
  contracts,
  navigate,
  count,
  loading,
  page,
  order,
  offset,
  handleOrder,
  handlePage,
  orderBy,
  handleChangeRowsPerPage
}) {
  const goTo = (uuid) => {
    if (hasPermission('FIND_CONTRACT')) {
      goToDatailsContract(navigate, uuid);
    }
  };

  const contractsList = contracts?.map((c) => {
    return (
      <TableRow
        key={c.id}
        onClick={() => goTo(c.uuid)}
        className={!hasPermission('FIND_CONTRACT') && 'not-effect'}
      >
        <TableCell>{c.id && c.id}</TableCell>
        <TableCell>
          <TargetStatus status={c.status} />
        </TableCell>
        <TableCell>{c.segments?.title?.toTitleCase()}</TableCell>
        <TableCell>{c.provider?.name?.toTitleCase()}</TableCell>
        <TableCell>{c.financialContract?.startDateFineRescission?.toMask('date') || '-'}</TableCell>
        <TableCell>{c.financialContract?.rescissionFine} dias</TableCell>
        <TableCell
          style={{
            whiteSpace: 'nowrap'
          }}
        >
          {c.indexCurrent?.name?.toUpperCase()}
        </TableCell>
        <TableCell>
          {convertCentsToWhole(c.financialContract?.initialValue, c.financialContract?.coin?.title)}
        </TableCell>
        <TableCell>
          {convertCentsToWhole(
            c.financialContract?.currentValue,
            c.financialContract?.coin?.title
          ) || '-'}
        </TableCell>
        <TableCell>{convertReadjustmentMonth(c.financialContract?.readjustmentMonth)}</TableCell>
      </TableRow>
    );
  });

  function RenderTable() {
    if (loading) {
      return <SkeletonDesktop numbersOfColumns={10} />;
    }

    return contractsList;
  }

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Id</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Classificação</TableCell>
              <TableCell>Fornecedor</TableCell>
              <TableCell>
                <TableSortLabel
                  direction={order}
                  active={order === Order.ASC && orderBy === 'startDateFineRescission'}
                  onClick={() => handleOrder('startDateFineRescission')}
                >
                  Data de início multa rescisória
                </TableSortLabel>
              </TableCell>
              <TableCell>Dias de multa rescisória</TableCell>
              <TableCell>Índice</TableCell>
              <TableCell>Valor inicial</TableCell>
              <TableCell>Valor atual</TableCell>
              <TableCell>Mês de reajuste</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <RenderTable />
          </TableBody>
        </Table>
      </TableContainer>
      <PaginationDesktop
        count={count}
        page={page}
        rowsPerPage={offset}
        handlePage={handlePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  );
}
